/**
 * PublishIcon/index.js
 * desc: publish icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const PublishIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="publish icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.publish.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path d="M2 0H16C17.11 0 18 0.9 18 2V16C18 17.1 17.11 18 16 18H2C0.89 18 0 17.1 0 16V2C0 0.9 0.89 0 2 0ZM2 9L7 14L16 5L14.59 3.58L7 11.17L3.41 7.59L2 9Z"/></svg>
    </IconButton>
);


export default PublishIcon;
